import * as React from 'react';
import { StyleSheet, Text, View, Image } from 'react-native';

import { getLocalizedTexts } from '../../Locales';
import { font } from '../../style/text';
import color from '../../style/color';
import { useWindowSize } from '../../style/utils';
import { getDevStackMode } from '../../lib/common/devStackMode';

const logo = { uri: '/assets/images/logos/logo-with-title-white.svg' };
const merchantIcon = { uri: '/assets/images/redesignedIcons/merchant.svg' };
const euroCircleIcon = { uri: '/assets/images/redesignedIcons/euro-circle.svg' };
const shoppingBagIcon = { uri: '/assets/images/redesignedIcons/shopping-bag.svg' };

function IntroPanel() {
    const texts = getLocalizedTexts().auth.intro;
    const size = useWindowSize();
    const devStackMode = getDevStackMode();
    return (
        <View style={[styles.container, devStackMode ? { backgroundColor: color.fairPink } : {}]}>
            <View style={{ height: size.height }}>
                <View style={styles.containerContent}>
                    <View style={styles.containerLogo}>
                        <Image source={logo} style={styles.imageLogo} />
                    </View>
                    <View style={styles.containerParagraphs}>
                        <Paragraph title={texts.paragraph1.title} message={texts.paragraph1.message} icon={merchantIcon} />
                        <Paragraph
                            title={texts.paragraph2.title}
                            message={texts.paragraph2.message}
                            icon={shoppingBagIcon}
                        />
                        <Paragraph title={texts.paragraph3.title} message={texts.paragraph3.message} icon={euroCircleIcon} />
                    </View>
                </View>
            </View>
        </View>
    );
}

export default IntroPanel;

function Paragraph({ title, message, icon }: { title: string; message: string; icon: { uri: string } }) {
    return (
        <View style={styles.containerParagraph}>
            <View style={styles.containerCheckMarkIcon}>
                <Image source={icon} style={styles.icon} />
            </View>
            <View style={styles.containerText}>
                <Text style={styles.textTitle}>{title}</Text>
                <Text style={styles.textMessage}>{message}</Text>
            </View>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'column',
        backgroundColor: color.black,
    },
    containerContent: {
        position: 'absolute',
        top: 60,
        right: 80,
        width: 300,
    },
    containerLogo: {
        marginLeft: 15,
    },
    containerParagraphs: {
        marginTop: 40,
    },
    containerParagraph: {
        flexDirection: 'row',
    },
    containerText: {
        flex: 1,
        marginLeft: 12,
    },
    containerCheckMarkIcon: {
        top: 2,
    },
    textTitle: {
        fontFamily: font.wallopSansSemiBold,
        fontSize: 16,
        color: color.white,
        marginBottom: 8,
    },
    textMessage: {
        fontFamily: font.wallopSansRegular,
        fontSize: 14,
        color: color.white,
        marginBottom: 25,
    },
    imageLogo: {
        width: 114,
        height: 55,
        resizeMode: 'contain',
        color: color.white,
    },
    icon: {
        width: 16,
        height: 16,
        color: color.white,
    },
});
